import React from "react";

import RealMap from "../../Maps/RealMap";

export default function MapPanel({ tasks = [], agents = [], teams = [] }) {
  return (
    <div className="relative z-0 flex-1 bg-gradient-to-br from-yellow-100 to-red-100">
      <RealMap Task={tasks} drivers={agents} teams={teams} showSearch={true} />
    </div>
  );
}
